import { useEffect, useRef, useState } from 'react'

import { useStore } from '../../store'
import CustomList from '../CommonComponents/CustomList';
import BackHeader from '../CommonComponents/BackHeader';
import api from '../../api/apiClient';
import { endpoints } from '../../api/endpoints';
import { DataType, SongDataType, SongType, storeType } from '../../types';
import { useLocation } from 'react-router-dom';
import Footer from '../CommonComponents/Footer';
import { useRouteTracker } from '../CommonComponents/RouteTracker';
import config from '../../config';

export default function CollectionList() {
  const {store, updateStoreFunc} = useStore();

  const {scrollPos, page, hasMore, loading, data} = store.collection;

  const location = useLocation();
  const collectionId = location.state.collectionId;
  const collectionName = location.state.collectionName;
  const firstMounted = useRef(true);

  const fetchData = async () => {
    if(page === 1) updateStoreFunc('collection','loading',true);
    let p = page;

    const result: any = await api.get(endpoints.collection.getSongsByCollection + `?collectionId=${collectionId}&current=${p}&limit=10`);

    updateStoreFunc("collection", "dataApi",endpoints.collection.getSongsByCollection + `?collectionId=${collectionId}&current=${p + 1}&limit=30`);

    if(p === 1) updateStoreFunc('collection','loading',false);
    if(result.code === '200'){
      updateStoreFunc(null,null,null,(pre: storeType['store']) => {
          const d : SongDataType = result.data;
          let arr: any;
          let o = {...pre};
          let a: any = {...o.collection.data};
          if(p > 1){
            arr = [...a?.by,...d?.by]
            a.by = arr;
            o.collection.data = a;
            return o;
          }else{
            a = d;
            o.collection.data = a;
            return o;
          }
      })
    }else{
      if(p > 1){
        updateStoreFunc('collection','hasMore',false);
      }else{
        updateStoreFunc('collection','hasMore',false);
        updateStoreFunc('collection','data',null)
      }
    }
  }
  
  useEffect(() => {
    if(firstMounted.current && data) return;
    fetchData();
  },[page])

  useEffect(() => {
    if(firstMounted.current) return;
    if(data?.by?.length === data?.pagination?.total) updateStoreFunc('collection','hasMore',false);
  },[data])

  const handleFetchMore = () => {
    updateStoreFunc('collection','page', page + 1)
  }

  const handleScroll = (event: any) => {
    const scrollTop = event.target.scrollTop;
    updateStoreFunc('collection','scrollPos',scrollTop);
  }

  useEffect(()=> {
    if(firstMounted.current) firstMounted.current = false;
    return () => {
      if(window.location.pathname === "/home"){
        updateStoreFunc('collection','data', null);
        updateStoreFunc('collection','hasMore', true);
        updateStoreFunc('collection','page', 1);
      }
    }
  },[])

  return ( 
    <div>
      <div style={{display: "flex", alignItems: "center", position: "relative"}}>
        <BackHeader/>
        <h1 style={{position: 'absolute', top: 0, left: "50%",transform: 'translate(-50%, 0)',color: "white", fontSize: "18px", marginTop: "15px", whiteSpace: "nowrap"}}>
          {collectionName}
        </h1>
      </div>
      <div style={{padding: "0 15px"}}>
          <CustomList
            data={data}
            type={'Song'}
            showFavorite
            loading={loading}
            handleFetchMore={handleFetchMore}
            hasMore={hasMore}
            scrollHeight={store.screenHeight - 55 + (store.screenType === 'mobile' ? config.footerHeight : 0)}
            dataApi={store.collection.dataApi}
            handleScroll={handleScroll}
            scrollPos={scrollPos}
          />
      </div>
      {
        store.screenType !== "mobile" && <Footer/>
      }
    </div>
  )
}
